import { api } from "..";

interface ResetAgentStepUpPasswordPayload {
  agentId: number;
}

export async function resetAgentStepUpPassword(
  payload: ResetAgentStepUpPasswordPayload
): Promise<{ success: boolean }> {
  const res = await api.client.post(
    `/agents-new/${payload.agentId}/reset-step-up-password`
  );
  return res.data;
}
